import graphql from 'api/graphql'
import {
  FETCH_TICKET_LINKED_RESOURCES_FAIL,
  FETCH_TICKET_LINKED_RESOURCES_REQUEST,
  FETCH_TICKET_LINKED_RESOURCES_SUCCESS,
} from 'constants/action_types'
import { oauthTokenSelector } from 'selectors/app'
import debug from 'util/debug'

export function doFetchTicketLinkedResources(ticketId) {
  return (dispatch, getState) => {
    if (ticketId === 'new') return false
    if (!ticketId) return false

    const state = getState()
    const token = oauthTokenSelector(state)

    const query = `
      query TicketActionsQuery($id: Int) {
        ticket(id: $id) {
          linkedExternalResources {
            externalId
            linkedAt
            provider
            title
            url
          }
        }
      }
    `

    const variables = {
      id: ticketId,
    }

    dispatch({
      type: FETCH_TICKET_LINKED_RESOURCES_REQUEST,
      meta: { ticketId },
    })

    return graphql(token, query, variables)
      .then(res => {
        const data = res.json.data
        dispatch({
          type: FETCH_TICKET_LINKED_RESOURCES_SUCCESS,
          meta: { ticketId },
          payload: data.ticket.linkedExternalResources,
        })
      })
      .catch(err => {
        debug(err)
        dispatch({
          type: FETCH_TICKET_LINKED_RESOURCES_FAIL,
          error: true,
          meta: { ticketId },
          payload: err,
        })
      })
  }
}
